export default __webpack_public_path__ + "static/media/long.0bc4a064.svg";